"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductViewerTableContainer = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const column_filter_1 = require("./column-filter");
const commenting_1 = require("./commenting");
const table_styles_1 = require("./table.styles");
const table_utils_1 = require("./table.utils");
const bulk_actions_toolbar_1 = require("../../components/bulk-actions-toolbar");
const table_1 = require("../../components/table");
const filter_1 = require("../filter");
const hooks_1 = require("../../../hooks");
const localization_1 = require("../../../localization");
const chips_1 = require("../../chips");
const components_1 = require("../../components");
const hooks_2 = require("../../hooks");
const store_1 = require("../../../store");
const State = __importStar(require("../../../store/state"));
const LS_ACTIVE_COLUMNS = 'ProductViewer_Table_ActiveColumns';
const LS_COLUMN_FILTER = 'ProductViewer_Table_Column_Filter';
const SEARCHABLE_FIELDS = ['title', 'description', 'proprietaryId'];
const leftEmptyColumn = { label: '' };
const ProductViewerTableContainer = ({ lastSelectedRowId, setLastSelectedRowId }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { addSuccess } = (0, hooks_1.useNotification)();
    const [isSingleCommentingDialogOpen, setIsSingleCommentingDialogOpen] = (0, react_1.useState)(false);
    const [isBulkCommentingDialogOpen, setIsBulkCommentingDialogOpen] = (0, react_1.useState)(false);
    const [selectedProduct, setSelectedProduct] = (0, react_1.useState)(null);
    const { attributeNameOptions, isLoading: areAttributesLoading } = (0, hooks_2.useAttributes)();
    const taxonomyClasses = (0, store_1.useClassesSelector)();
    const { handleSearch, searchFilter, searchQuery } = (0, hooks_2.useTableSearch)(SEARCHABLE_FIELDS, setLastSelectedRowId);
    const { sortParams, handleSort } = (0, hooks_2.useTableSort)();
    const { anchorEl, openColumnFilter, closeColumnFilter, getColumnFilterValue, isColumnFilterActive, updateColumnFilter, } = (0, hooks_2.useColumnFilter)(LS_COLUMN_FILTER);
    const { getFilters, activeFilter } = (0, hooks_2.useFilter)({ searchFilter });
    const filter = (0, react_1.useMemo)(() => getFilters().filter, [getFilters]);
    const { currentPage, rowsPerPage, handlePageChange, handleRowsPerPageChange, } = (0, hooks_2.useTablePagination)(filter, setLastSelectedRowId);
    const { isLoading, products, updateProducts } = (0, hooks_2.useLoadProducts)({
        filter,
        currentPage,
        rowsPerPage,
        sortParams,
    });
    const additionalColumns = (0, react_1.useMemo)(() => [
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_COMMENTS' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.COMMENTS,
            description: t({ key: 'DEFAULT' }),
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_CURATED_ATTRIBUTES' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.CURATED_ATTRIBUTES,
        },
        {
            label: t({ key: 'PRODUCT_EDITOR_TABLE_COLUMNS_STANDARD_FIELDS' }),
            id: State.PRODUCT_EDITOR_TABLE_COLUMNS.STANDARD_FIELDS,
        },
        ...attributeNameOptions,
    ], [attributeNameOptions]);
    const { activeColumns, columns, defaultColumns, handleSetActiveColumns, } = (0, hooks_2.useRefineModal)({
        lsKey: LS_ACTIVE_COLUMNS,
        additionalColumns,
        additionalDefaultColumnNames: [State.PRODUCT_EDITOR_TABLE_COLUMNS.COMMENTS],
    });
    const additionalTemplate = (0, react_1.useMemo)(() => attributeNameOptions.reduce((attributeTemplates, attributeOption) => {
        attributeTemplates[attributeOption.id] = { align: 'left', label: attributeOption.label };
        return attributeTemplates;
    }, {}), [attributeNameOptions]);
    const tableColumns = (0, hooks_2.useTableColumns)({ activeColumns, additionalTemplate });
    const productViewerTableColumns = [leftEmptyColumn, ...tableColumns];
    const total = (0, store_1.useProductsTotal)();
    const { handleAllProductsSelect, handleProductSelect, selectedProductsCount, selectedProductsForPage, } = (0, hooks_2.useSelectedProducts)({
        lastSelectedRowId,
        setLastSelectedRowId,
        products,
    });
    const handleCommentClick = (product) => () => {
        setSelectedProduct(product);
        setIsSingleCommentingDialogOpen(true);
    };
    const handleSingleCommentingDialogClose = (isAtLeastOneCommentAdded) => __awaiter(void 0, void 0, void 0, function* () {
        setIsSingleCommentingDialogOpen(false);
        if (isAtLeastOneCommentAdded) {
            yield updateProducts([selectedProduct.id]);
            addSuccess(t({ key: 'SINGLE_COMMENTING_SUCCESS_MESSAGE' }));
        }
        setSelectedProduct(null);
    });
    const handleBulkCommentingDialogClose = (isAtLeastOneCommentAdded) => __awaiter(void 0, void 0, void 0, function* () {
        if (isAtLeastOneCommentAdded) {
            const selectedIds = selectedProductsForPage.map(({ id }) => id);
            setLastSelectedRowId(null);
            dispatch((0, store_1.setIsExclusionModeOn)(false));
            dispatch((0, store_1.clearAllSelectedProducts)());
            setIsBulkCommentingDialogOpen(false);
            yield updateProducts(selectedIds);
            addSuccess(t({ key: 'BULK_COMMENTING_SUCCESS_MESSAGE', values: { count: selectedIds.length } }));
        }
        else {
            setIsBulkCommentingDialogOpen(false);
        }
    });
    const getAdditionalRows = (0, react_1.useCallback)((product, options) => {
        var _a;
        const { classId, totalComments, attributes } = product;
        const attributeRows = attributes.reduce((attributesMap, attribute) => {
            attributesMap[attribute.id] = (react_1.default.createElement(table_1.AttributeValuesCell, { key: attribute.id, attributeValues: attribute.values, expanded: options === null || options === void 0 ? void 0 : options.isExpanded }));
            return attributesMap;
        }, {});
        return Object.assign({ [State.PRODUCT_EDITOR_TABLE_COLUMNS.CLASS]: react_1.default.createElement(table_1.TextCell, { key: "class" }, (_a = taxonomyClasses === null || taxonomyClasses === void 0 ? void 0 : taxonomyClasses.byId[classId]) === null || _a === void 0 ? void 0 : _a.title), [State.PRODUCT_EDITOR_TABLE_COLUMNS.COMMENTS]: react_1.default.createElement(table_1.CommentCell, { key: "comments", total: totalComments, onCommentClick: handleCommentClick(product) }) }, attributeRows);
    }, [taxonomyClasses === null || taxonomyClasses === void 0 ? void 0 : taxonomyClasses.byId]);
    const getTableRows = (0, hooks_2.useTableRows)({ activeColumns, getAdditionalRows, getColumnFilterValue });
    const handleChipsClear = () => {
        setLastSelectedRowId(null);
    };
    (0, react_1.useEffect)(() => {
        setLastSelectedRowId(null);
        dispatch((0, store_1.setIsExclusionModeOn)(false));
        dispatch((0, store_1.clearAllSelectedProducts)());
    }, [filter]);
    const handleFilterClick = (0, react_1.useCallback)(({ id }, anchor) => openColumnFilter(id, anchor), [openColumnFilter]);
    const isFilterActive = (0, react_1.useCallback)(({ id }) => isColumnFilterActive(id), [isColumnFilterActive]);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(table_styles_1.StyledTableToolbar, null, react_1.default.createElement(filter_1.ProductViewerFilter, { searchQuery: searchQuery, onSearch: handleSearch, activeColumns: activeColumns, columns: columns, defaultColumns: defaultColumns, setActiveColumns: handleSetActiveColumns, disabled: isLoading })), react_1.default.createElement(chips_1.ChipsContainer, { onClear: handleChipsClear }), react_1.default.createElement(components_1.TableSelectionButtons, { setLastSelectedRowId: setLastSelectedRowId }), selectedProductsCount > 0 && (react_1.default.createElement(bulk_actions_toolbar_1.BulkActionsToolbar, { onBulkCommentActionClick: () => setIsBulkCommentingDialogOpen(true), total: total, selectedCount: selectedProductsCount })), react_1.default.createElement(components_1.ProductEditorTable, { isExpandable: true, columns: productViewerTableColumns, currentPage: currentPage, isLoading: isLoading, products: products, rowsPerPage: rowsPerPage, sortParams: sortParams, getTableRows: getTableRows, onSort: handleSort, onPageChange: handlePageChange, onRowsPerPageChange: handleRowsPerPageChange, total: total, onSelect: handleProductSelect, onSelectAll: handleAllProductsSelect, selectedRows: selectedProductsForPage, shouldRowBeHighlighted: table_utils_1.shouldRowBeHighlighted, onFilterClick: handleFilterClick, isFilterActive: isFilterActive, checkboxColumnOrder: 1 }), isSingleCommentingDialogOpen && selectedProduct && (react_1.default.createElement(commenting_1.SingleCommentingDialog, { product: selectedProduct, onClose: handleSingleCommentingDialogClose })), isBulkCommentingDialogOpen && (react_1.default.createElement(commenting_1.BulkCommentDialog, { selectedCount: selectedProductsCount, activeFilter: activeFilter, onClose: handleBulkCommentingDialogClose })), anchorEl && (react_1.default.createElement(column_filter_1.ColumnFilter, { anchorEl: anchorEl, isLoading: areAttributesLoading, onClose: closeColumnFilter, filterOptions: attributeNameOptions, selected: getColumnFilterValue(), onApply: updateColumnFilter }))));
};
exports.ProductViewerTableContainer = ProductViewerTableContainer;
exports.default = exports.ProductViewerTableContainer;
